export default "__VITE_ASSET__a34dbc38__"